export default __webpack_public_path__ + "static/media/alerts.30e14182.PNG";